import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Slick from "./Slick"
import { useTranslation } from "react-i18next"

export default function BlogSection() {
  const { t } = useTranslation()
  return (
    <section className="blog-area bg-light py-5" id="blog">
      <Container>
        <Row>
          <Col lg={12} className="blog-content mt-60">
            <h1 className="title-section">Blog</h1>
            <h6 className="sub-title">{t("activity")}</h6>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Slick />
          </Col>
        </Row>
      </Container>
    </section>
  )
}
